import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Da5100Class}from '../../Class/da5100/da5100-class'
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class Da5100Service {

  //baseUrl: string='https://localhost:44371/api/da5110/';
 // constructor(private http:HttpClient) { }

  
  baseUrl: string=environment.baseUrl + 'da5100/';
  constructor(private http:HttpClient) { }

GetCommonControlNames(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
}

GetControlNames():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetControlNames');
}

//Load saved data in to find section
LoadControls():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadControls');
}

//Load saved data in to find section
LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}

ChangeVariable(Da5100Class: Da5100Class): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'ChangeVariable', Da5100Class);
}

//Select an entry from find section
DoFind(Da5100Class:Da5100Class):Observable<any>
{
  
  return this.http.post<any>(this.baseUrl+'doFind',Da5100Class);
}

//Add or Edit an entry
Create(attendance_class:Da5100Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl+'Create',attendance_class);
}
Insert(attendance_class:Da5100Class): Observable<any>
{
 
  return this.http.post<any>(this.baseUrl+'Insert',attendance_class);
}

//Delete an entry
Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}
//Report
Report(id):Observable<any>
{

  return this.http.get<any>(this.baseUrl+'Report/'+id);
}
load(Da5100Class:Da5100Class):Observable<any>
{
 
  return this.http.post<any>(this.baseUrl+'load',Da5100Class);
}

update(attendance_class:Da5100Class): Observable<any>
{
  
  return this.http.post<any>(this.baseUrl+'Update',attendance_class);
}

check():Observable<any>
{
  
  return this.http.get<any>(this.baseUrl+'check');
}

loadlocation():Observable<any>
{
  
  return this.http.get<any>(this.baseUrl+'loadlocation');
}
CheckLocation(Da5100Class:Da5100Class):Observable<any>
{
  return this.http.post<any>(this.baseUrl+'CheckLocation',Da5100Class);
}


// ===== WEB (biometricdevicelogs) =====
checkinWeb(attendance_class: Da5100Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl + 'CheckInWeb', attendance_class);
}

checkoutWeb(attendance_class: Da5100Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl + 'CheckOutWeb', attendance_class);
}

loadWeb(attendance_class: Da5100Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl + 'LoadWeb', attendance_class);
}


}
